export default __webpack_public_path__ + "static/media/email-confirmed.21e44e7d.png";